import {h, Fragment} from "preact"
import { useAppState } from "@nosto/preact"

import NoResults from "./NoResults"
import Products from "./Products"
import Toolbar from "./Toolbar"
import Sidebar from "./Sidebar"
import BottomToolbar from "./BottomToolbar"
// import SelectedFilters from "./SelectedFilters"
import Loader from "./elements/Loader"
import { useState, useEffect } from "preact/hooks"

export default function Category() {
    const {
        response: { products },
        loading
    } = useAppState()
    const foundProducts = products && products.total > 0

    // const categoryString = document.querySelector(".nosto_category > .category_string").textContent;

    const [sidebarIsShown, setSidebarIsShown] = useState(false);

    const handleToggleSidebar = () => {
        setSidebarIsShown(!sidebarIsShown);
    };

    //Uncomment if the client wants no scroll when sidebar is active
    // useEffect(() => {
    //     if (sidebarIsShown) {
    //         document.body.style.overflow = 'hidden';
    //     } else {
    //         document.body.style.overflow = 'auto';
    //     }
    //     return () => {
    //         document.body.style.overflow = 'auto';
    //     };
    // }, [sidebarIsShown]);

    return (
    <div class="ns-serp-container">
        <div class="ns-serp-wrapper">
            {/* <section class="ns-breadcrumbs" role="navigation" aria-label="breadcrumbs" data-product-breadcrumbs="">
                <div class="ns-breadcrumbs-wrapper">
                    <a href="/" title="Home">Home /&nbsp;</a>
                    <span class="ns-breadcrumbs-current">{categoryString}</span>
                </div>
            </section> */}
            {foundProducts && (
                <>
                    <Sidebar sidebarIsShown={sidebarIsShown} onToggleSidebar={handleToggleSidebar} />
                    {/* <Toolbar mobile /> */}
                </>
            )}
            <div>
                {foundProducts ? (
                    <>
                        {/* <SelectedFilters /> */}
                        <Toolbar onToggleSidebar={handleToggleSidebar} />
                        <Products />
                        <BottomToolbar />
                    </>
                ) : loading ? (
                    <Loader />
                ) : (
                    <NoResults />
                )}

                {/* To enable InfiniteScroll - comment above block and uncomment below.
                    Don't forget to import InfiniteScroll component. */}
                {/* {foundProducts ? (
                    <>
                        <SelectedFilters />
                        <Toolbar />
                        <InfiniteScroll>
                            <Products />
                        </InfiniteScroll>
                    </>
                ) : loading ? (
                    <Loader />
                ) : (
                    <NoResults />
                )} */}
            </div>
        </div>
    </div>
    )
}
